import { Injectable } from '@angular/core';
import { LicensedModuleDto } from './customer-client/translation.service';
import { RestApiClientAdapterService } from '../sysbiz/rest-api-client-adapter.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { AuthService, IDtoGuid, PagedResultDto, SortDirectionDto } from '@systems/base';
import { CUSTOMERAPICLIENT_CONFIG } from '../sysbiz/config-loader.service';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ContractService extends RestApiClientAdapterService<CompanyContract, CompanyContract, CompanyContract> {

  constructor(
    protected override http: HttpClient,
    authService: AuthService,
    protected translationService: TranslateService
  ) {
    super(CUSTOMERAPICLIENT_CONFIG, http, authService, 'companycontract');
  }
  public listOpenContracts(pageSize: number, pageNumber: number,): Observable<PagedResultDto<CompanyContract>> {

    let params = new HttpParams();

    if (pageNumber) {
      params = params.append('pageNumber', pageNumber as any);
    }
    if (pageSize) {
      params = params.append('pageSize', pageSize as any);
    }

    return this.http.get<PagedResultDto<CompanyContract>>(this.getUrl(`companies/listOpenContracts`),
      {
        responseType: 'json',
        observe: 'response',
        headers: {
          authenticate: this.authService.authenticationToken ?? ""
        },
        params
      }).pipe(map((resp: any) => {
        this.updateTokenFromResponse(resp);
        return resp.body;
      }));
  }

  public createNewExistingContract(contractGuid: string): Observable<CompanyContract> {
    return this.http.post<CompanyContract>(
      this.getUrl(`companycontract/${contractGuid}`),
      null,
      {
        responseType: 'json',
        observe: 'response',
        headers: {
          authenticate: this.authService.authenticationToken ?? "",
        },
      }
    ).pipe(
      map((resp: any) => {
        this.updateTokenFromResponse(resp);
        return resp.body!;
      })
    );
  }


  public listByFilters(
    sorting?: ContractSortingDto,
    sortDirection?: SortDirectionDto,
    pageNumber?: number,
    pageSize?: number,
    filter?: CompanyContractFilterDto
  ): Observable<PagedResultDto<CompanyContract>> {
    let params = new HttpParams();

    if (sorting) {
      params = params.append('sorting', sorting as any);
    }
    if (sortDirection) {
      params = params.append('sortDirection', sortDirection as any);
    }
    if (pageNumber) {
      params = params.append('pageNumber', pageNumber as any);
    }
    if (pageSize) {
      params = params.append('pageSize', pageSize as any);
    }

    if (filter?.companyGuid) {
      params = params.append('companyGuid', filter.companyGuid as any);
    }
    if (filter?.userGuid) {
      params = params.append('userGuid', filter.userGuid as any);
    }
    if (filter?.onlyOpen || filter?.onlyOpen == false) {
      params = params.append('onlyOpen', filter.onlyOpen as any);
    }


    return this.http.get<PagedResultDto<CompanyContract>>(this.getUrl(`companycontract/contracts`),
      {
        responseType: 'json',
        observe: 'response',
        headers: {
          authenticate: this.authService.authenticationToken ?? ""
        },
        params
      }).pipe(map((resp: any) => {
        this.updateTokenFromResponse(resp);
        return resp.body;
      }));
  }

  public callbackContractSign(contractGuid: string, data: CompanyContractCallbackDto): Observable<CompanyContract> {
    return this.http.post<CompanyContract>(
      this.getUrl(`companycontract/${contractGuid}/callback`),
      data,
      {
        responseType: 'json',
        observe: 'response',
        headers: {
          authenticate: this.authService.authenticationToken ?? "",
        },
      }
    ).pipe(
      map((resp: any) => {
        this.updateTokenFromResponse(resp);
        return resp.body;
      })
    );
  }

}


export interface CompanyContract extends IDtoGuid {
  licensedModule: LicensedModuleDto;
  companyName: string;
  contractGuid: string;
  contractName: string;
  companyGuid: string;
  state: ContractState;
  signerLinkToken: string;
  createdUtc: Date;
  canCurrentUserSign?: boolean;
}

export enum ContractState {
  ToDo = "ToDo",
  Sent = "Sent",
  Signed = "Signed",
  Rejected = "Rejected",
  ToVerify = "ToVerify",
  Cancelled = "Cancelled"
}

export interface CompanyContractCallbackDto {
  newState: ContractState;
}

export interface CompanyContractFilterDto {
  userGuid?: string;
  companyGuid?: string;
  onlyOpen?: boolean;
}

export enum ContractSortingDto {
  name = 'Name',
}
